<template>
  <div style="width: 100%">
    <div class="common_top_box_space flex Flexjustify Flexalign">
      <div class="common_top_box flex FlexBetween Flexalign">
        <div class="cursor_pointer flex Flexalign">
          <el-image class="gjkc_index_logo" :src="iconPath('gjkc_index_logo.png')" @click="goHome"></el-image>
          <!-- <el-select v-model="gjkcTypeValue" style="width: 200px" @change="changeGjkcType" :key="refreshey1">
            <el-option v-for="item in gjkcTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
          <div class="menu_list flex">
            <div class="menu_one flex flexcolumn Flexalign cursor_pointer" v-for="(item, index) in gjkcTypeOptions"
              :key="index" @click="changeGjkcType(item.value)">
              <div :class="[item.value == gjkcTypeValue ? 'active_text' : '']">
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex Flexalign FlexAround common_top_box_right">
          <div class="top_input_box top_search_box" @mouseenter="showSearchdown" @mouseleave="hideSearchdown">
            <el-input v-model="courseName" style="max-width: 600px; min-width: 280px" placeholder="搜一搜你感兴趣的课程吧"
              class="input-with-select" @keyup.enter="searchCourse(courseName)">
              <template #append>
                <div class="btn_search cursor_pointer cursor_pointer" @click="searchCourse(courseName)">
                  搜索
                </div>
              </template>
            </el-input>
            <div class="search_tooltip_box" v-if="isOpenSearch">
              <div class="hot_title text_active">热门搜索</div>
              <div class="hot_search_list flex FlexWrap">
                <div class="hot_search_list_one mar_top_15 toverflow" v-for="(item, index) in hotSearchList"
                  :key="index">
                  <div class="toverflow cursor_pointer" style="width: 80%" @click="searchCourse(item)">
                    {{ item }}
                  </div>
                </div>
              </div>
              <div class="flex FlexBetween Flexalign mar_top_20" v-if="historySearchList?.length">
                <div class="hot_title">搜索历史</div>
                <!-- <el-icon class="cursor_pointer" :size="24" @click="deleteHistorySearch">
                <DeleteFilled />
              </el-icon> -->
                <el-image class="top_search_delete_icon cursor_pointer" @click="deleteHistorySearch"
                  :src="iconPath('top_search_delete_icon.png')"></el-image>
              </div>
              <div class="toverflow mar_top_15 history_list">
                <span class="history_list_one cursor_pointer" v-for="(item, index) in historySearchList" :key="index"
                  :style="index == 0 ? 'margin:0;' : ''" @click="searchCourse(item)">{{ item }}</span>
              </div>
            </div>
          </div>
          <div class="area_box flex Flexalign FlexEvenly cursor_pointer" @mouseenter="showDropdown"
            @mouseleave="hideDropdown">
            <div style="margin-top: 4px">
              <el-image class="position_icon" :src="imgPath('position_icon.png')"></el-image>
            </div>
            <!-- <div class="">{{ selectedCityInfo.cityName }}</div> -->
            <moe-tooltip :contentText="selectedCityInfo.cityName" :contentWidth="60"></moe-tooltip>
            <el-icon>
              <ArrowDown />
            </el-icon>
            <div class="dropdown-menu" v-if="isOpen">
              <div class="hotCity">热门城市</div>
              <div class="flex FlexWrap FlexBetween">
                <div class="dropdown-item cursor_pointer" v-for="(item, index) in hotCityList" :key="index"
                  @click="selectCity(item)" :class="[item.cityId == selectedCityInfo.cityId ? 'active_city' : '']">
                  {{ item.cityName }}
                </div>
              </div>
              <div class="more-cities flex FlexjustifyEnd Flexalign cursor_pointer" @click="showMoreCities">
                更多城市
                <el-icon color="#666666">
                  <ArrowRight />
                </el-icon>
              </div>
            </div>
          </div>
          <div class="flex top_btn_box">
            <!-- <div class="btn_outline cursor_pointer" :class="[topSelectedMenu == 0 ? 'active_top_menu' : '']"
              @click="changeTopMenu(0)">
              首页
            </div> -->
            <!-- <div class="btn_outline cursor_pointer" :class="[topSelectedMenu == 1 ? 'active_top_menu' : '']"
            @click="changeTopMenu(1)">
            教师中心
          </div> -->
            <div class="btn_outline cursor_pointer" :class="[topSelectedMenu == 2 ? 'active_top_menu' : '']"
              @click="changeTopMenu(2)">
              学习中心
            </div>
            <div class="btn_outline cursor_pointer" :class="[topSelectedMenu == 6 ? 'active_top_menu' : '']"
              @click="changeTopMenu(6)">
              试卷中心
            </div>
            <!-- <div class="btn_outline cursor_pointer" :class="[topSelectedMenu == 3 ? 'active_top_menu' : '']"
          @mouseenter="showMemberdown" @mouseleave="hideMemberdown" @click="changeTopMenu(3)">
          会员专区
          <div class="member_benefits" v-if="isOpenMember">
            <div class="member_benefits_top flex Flexjustify Flexalign">
              <el-image class="line_y_left" :src="imgPath('line_y_left.png')"></el-image>
              <div class="title_text">会员权益</div>
              <el-image class="line_y_left" :src="imgPath('line_y_right.png')"></el-image>
            </div>
            <div class="member_benefits_content Flexalign flex FlexWrap">
              <div class="flex Flexalign content_one">
                <el-image class="video_y_icon" :src="imgPath('video_y_icon.png')"></el-image>
                <div class="video_text">畅学1500+视频</div>
              </div>
              <div class="flex Flexalign content_one">
                <el-image class="video_y_icon" :src="imgPath('course_y_icon.png')"></el-image>
                <div class="video_text">13000元课程免费看</div>
              </div>
              <div class="flex Flexalign content_one">
                <el-image class="video_y_icon" :src="imgPath('coupon_y_icon.png')"></el-image>
                <div class="video_text">全年1440元礼券</div>
              </div>
              <div class="flex Flexalign content_one">
                <el-image class="video_y_icon" :src="imgPath('textbook_y_icon.png')"></el-image>
                <div class="video_text">配套教材下载</div>
              </div>
            </div>
            <div class="flex Flexjustify Flexalign">
              <div class="btn_open_member">开通会员</div>
            </div>
            <div>
              <el-image class="member_bg" :src="imgPath('member_bg.png')"></el-image>
            </div>
          </div>
        </div> -->
            <!-- <div class="btn_outline cursor_pointer" :class="[topSelectedMenu == 4 ? 'active_top_menu' : '']" @click="changeTopMenu(4)">
          积分商城
        </div> -->
          </div>
          <div class="top_icon_box flex">
            <div class="cursor_pointer" style="margin-left: 20px" @click="goCart">
              <div v-if="myCarList">
                <el-badge :value="myCarList?.length" :max="99" class="item" v-if="myCarList.length">
                  <el-image class="car_icon" :src="imgPath('car_icon.png')"></el-image>
                </el-badge>
                <el-image class="car_icon" :src="imgPath('car_icon.png')" v-else></el-image>
              </div>
            </div>
            <div class="cursor_pointer" style="margin-left: 35px" @click="goMessage">
              <el-badge :value="unReadMessageNum" :max="99" class="item" :show-zero="false">
                <el-image class="car_icon" :src="imgPath('message_icon.png')"></el-image>
              </el-badge>
              <!-- <el-badge :value="messageNum" :max="99" class="item" v-if="messageNum">
                <el-image class="car_icon" :src="imgPath('message_icon.png')"></el-image>
              </el-badge>
              <el-image class="car_icon" :src="imgPath('message_icon.png')" v-else></el-image> -->
            </div>
          </div>
          <div class="login_box cursor_pointer">
            <div class="cursor_pointer" v-if="!isLogin" @click="login">登陆/注册</div>
            <div class="user_avatar_box" @mouseenter="showUserInfo" @mouseleave="hideUserInfo" v-else>
              <el-avatar class="user_avatar" :size="32" :src="imgPath(userInfo.headImage)"
                @click="goPersonalCenter"></el-avatar>
              <div class="user_info_box flex flexcolumn Flexalign" v-if="isOpenUserInfo">
                <div class="cursor_pointer" @click="goOrderList">我的订单</div>
                <div class="cursor_pointer" @click="goCart">购物车</div>
                <div class="cursor_pointer" @click="goCoupon">优惠券</div>
                <div class="cursor_pointer" @click="goIntegralCenter">积分任务</div>
                <div class="cursor_pointer" @click="goSetting">个人设置</div>
                <div class="cursor_pointer" @click="quitLogin">退出登录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <login ref="login" @refreshPage="refreshPage"></login>
      <intersting ref="intersting"></intersting>
    </div>
    <!-- 处理position不占位问题 -->
    <div class="moe_top"></div>
  </div>
</template>

<script>
import area from "@/assets/data/area";
import intersting from "../popup/intersting.vue";
import login from "../popup/login.vue";
import { mapState } from "vuex";
import { conversationList, queryFriendApplyList } from "@/views/goEasy/api/im.js";
import { getStationUnReadNum as getStationUnReadNumApi } from "@/api/moudules/message.js";
import emitter from "@/utils/emitter";
export default {
  name: "moeTop",
  components: {
    login,
    intersting,
  },
  data() {
    return {
      selectedCityInfo: {
        cityName: "",
        cityId: "",
      },
      isOpen: false,
      hotCityList: [],
      isOpenMember: false,
      isLogin: false,
      isOpenUserInfo: false,
      location: {},
      ifFirstLogin: false,
      courseName: "",
      topSelectedMenu: 0,
      isOpenSearch: false,
      hotSearchList: [],
      // historySearchList: [
      //   { label: "期末专业提分", value: 1 },
      //   { label: "其中考试速成课", value: 1 },
      //   { label: "其中考试速成课名...", value: 1 },
      // ]
      gjkcTypeOptions: [],
      gjkcTypeValue: "",
      refreshey1: 1,
      messageNum: 0,
      unReadMessageNum: 0, // 未读消息数
      unreadRefreshTimer: null,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      selectArea: (state) => state.area.selectArea,
      showLogin: (state) => state.showLogin,
      historySearchList: (state) => state.user.historySearchList,
      myCarList: (state) => state.user.myCarList,
      isSettingInterest: (state) => state.user.isSettingInterest,
      selectCourseType: (state) => state.user.selectCourseType,
      courseTypeList: (state) => state.filter.courseTypeList,
    }),
  },
  watch: {
    courseTypeList: {
      handler(value) {
        this.refreshey1++;
        if (!this.$Tools.empty(value)) {
          this.gjkcTypeOptions = value;
        }
      },
      deep: true,
      immediate: true,
    },
    selectCourseType: {
      handler(value) {
        if (!value) {
          setTimeout(() => {
            this.$store.commit("user/setSelectCourseType", this.courseTypeList[0]?.value);
          }, 500);
        }
        this.gjkcTypeValue = value;
      },
      deep: true,
      immediate: true,
    },
    userInfo: {
      handler(value) {
        if (value.buyerUserId) {
          this.isLogin = true;
          this.getAllUnReadNum();
        } else {
          this.isLogin = false;
          this.messageNum = 0;
          this.unReadMessageNum = 0;
        }
        // 判断是否设置过兴趣爱好（学段/地区/学科是否为空）
        if (!this.$Tools.empty(value)) {
          // 判断是否弹过兴趣爱好设置框（true则不再弹起）
          if (!this.isSettingInterest) {
            if (!value.atStageIds || !value.atSubjectIds || !value.provinceCode) {
              setTimeout(() => {
                if (this.$refs.intersting) {
                  this.$refs.intersting.interstingShow = true;
                  this.$store.commit("user/setIsSettingInterest", true); // 设置缓存，不重复弹起兴趣爱好设置框
                }
              }, 1500);
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
    selectArea: {
      handler(value) {
        this.selectedCityInfo = value;
      },
      deep: true,
      immediate: true,
    },
    showLogin: {
      handler(value) {
        if (value) {
          this.login();
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.$route.path == "/") {
      this.topSelectedMenu = 0;
    } else if (this.$route.path == "/teacher") {
      this.topSelectedMenu = 1;
    } else if (this.$route.path == "/learningCenter") {
      this.topSelectedMenu = 2;
    } else if (this.$route.path == "/testPaperCenter") {
      this.topSelectedMenu = 5;
    } else {
      this.topSelectedMenu = "hide";
    }
    this.getHotCityList();
    this.getHotSearch();
    this.getCarList();
    this.getStationUnReadNum();
    this.getAllUnReadNum();
  },
  mounted() {
    if (this.showLogin && this.$route.path != "/passwordUpdate") {
      this.login();
    }
    this.bindUnreadEvents();
  },
  beforeUnmount() {
    if (this.unreadRefreshTimer) {
      clearTimeout(this.unreadRefreshTimer);
      this.unreadRefreshTimer = null;
    }
    this.unbindUnreadEvents();
  },
  methods: {
    /**
     * 聊天类消息到达时，先本地+1再触发服务端校准
     */
    onReceiveChatMessage() {
      // 先本地增量，确保右上角未读即时变化
      this.unReadMessageNum = Number(this.unReadMessageNum || 0) + 1;
      this.handleUnreadEvent();
    },
    /**
     * 统一未读刷新入口：立即刷新 + 延迟二次刷新
     */
    handleUnreadEvent() {
      this.getAllUnReadNum();
      if (this.unreadRefreshTimer) {
        clearTimeout(this.unreadRefreshTimer);
      }
      // 兼容后端未读数更新延迟
      this.unreadRefreshTimer = setTimeout(() => {
        this.getAllUnReadNum();
      }, 800);
    },
    /**
     * 系统消息页拉取的站内信未读与顶栏不一致时，以页面接口为准校正站内信及总未读
     * @param {{ total: number }} payload
     */
    onStationUnreadSync({ total }) {
      const next = Number(total) || 0;
      const prev = Number(this.messageNum) || 0;
      if (next === prev) return;
      this.messageNum = next;
      this.unReadMessageNum = Math.max(
        0,
        Number(this.unReadMessageNum || 0) - prev + next,
      );
    },
    /**
     * 绑定全局未读相关事件
     */
    bindUnreadEvents() {
      emitter.on("receivedMessage", this.onReceiveChatMessage);
      emitter.on("receivedImMessage", this.onReceiveChatMessage);
      emitter.on("receivedGroupMessage", this.onReceiveChatMessage);
      emitter.on("unread-status-changed", this.handleUnreadEvent);
      emitter.on("station-unread-sync", this.onStationUnreadSync);
    },
    unbindUnreadEvents() {
      emitter.off("receivedMessage", this.onReceiveChatMessage);
      emitter.off("receivedImMessage", this.onReceiveChatMessage);
      emitter.off("receivedGroupMessage", this.onReceiveChatMessage);
      emitter.off("unread-status-changed", this.handleUnreadEvent);
      emitter.off("station-unread-sync", this.onStationUnreadSync);
    },
    // 获取站内信未读数量
    getStationUnReadNum() {
      // 避免首页&改密码页面未登录弹登录框
      if (!this.userInfo?.buyerUserId) {
        return;
      }
      let listQuery = {
        platform: "wxy_pc",
      };
      this.$Api.message
        .getStationUnReadNum(listQuery)
        .then((res) => {
          this.messageNum = res.data.data.total;
        })
        .catch(() => { });
    },
    // 聚合未读：会话未读 + 站内信未读 + 好友申请未处理数
    getAllUnReadNum() {
      if (!this.userInfo?.buyerUserId) return;

      const goUserInfo = JSON.parse(localStorage.getItem("goUserInfo") || "{}");
      const hasGoUserId = !!goUserInfo?.userId;

      const conversationReq = hasGoUserId
        ? conversationList({
            userId: goUserInfo.userId,
            page: 1,
            pageSize: 100,
          })
        : Promise.resolve({ list: [] });

      const friendApplyReq = hasGoUserId
        ? queryFriendApplyList({
            userId: goUserInfo.userId,
            page: 1,
            pageSize: 100,
          })
        : Promise.resolve({ list: [] });

      const stationReq = getStationUnReadNumApi({ platform: "wxy_pc" });

      Promise.allSettled([conversationReq, stationReq, friendApplyReq]).then(
        ([conversationRes, stationRes, applyRes]) => {
          const conversationData =
            conversationRes.status === "fulfilled"
              ? (
                conversationRes.value?.list ||
                conversationRes.value?.data?.list ||
                conversationRes.value?.data?.data?.list ||
                []
              )
              : [];
          const chatUnread = conversationData.reduce(
            (sum, item) =>
              sum + (Number(item?.unreadCount ?? item?.unReadCount ?? item?.unread) || 0),
            0
          );

          const stationUnread =
            stationRes.status === "fulfilled"
              ? Number(stationRes.value?.data?.data?.total || 0)
              : 0;

          const applyList =
            applyRes.status === "fulfilled" && Array.isArray(applyRes.value?.list)
              ? applyRes.value.list
              : [];
          const friendApplyUnread = applyList.filter(
            (item) => Number(item?.status || 0) === 0
          ).length;

          this.unReadMessageNum = chatUnread + stationUnread + friendApplyUnread;
          this.messageNum = stationUnread;
        }
      );
    },
    // 积分中心
    goIntegralCenter() {
      this.$Jump.href("/integralCenter");
    },
    changeGjkcType(value) {
      this.$Jump.href("/");
      this.$store.commit("user/setSelectCourseType", value);
    },
    // 地区选择
    showDropdown() {
      this.isOpen = true;
    },
    hideDropdown() {
      this.isOpen = false;
    },
    // 搜索
    showSearchdown() {
      this.isOpenSearch = true;
    },
    hideSearchdown() {
      this.isOpenSearch = false;
    },
    // 会员权益
    showMemberdown() {
      this.isOpenMember = true;
    },
    hideMemberdown() {
      this.isOpenMember = false;
    },
    // 会员中心
    showUserInfo() {
      this.isOpenUserInfo = true;
    },
    hideUserInfo() {
      this.isOpenUserInfo = false;
    },
    selectCity(info) {
      this.selectCityInfo = info;
      this.isOpen = false;
      this.$store.commit("area/setReady", this.selectCityInfo);
    },
    showMoreCities() {
      this.$Jump.href("/city");
    },
    login() {
      this.$refs.login.showLogin = true;
      // 统一走 Vuex，避免 ref 未挂载时报错
      this.$store.commit("setShowLogin", true);
    },
    // 退出登录
    quitLogin() {
      // this.$store.commit("setUserInfo", {});
      // this.$store.commit("setToken", "");
      this.$Auth.logout();
    },
    // 刷新页面
    refreshPage() {
      window.location.reload();
    },
    // 购物车
    goCart() {
      this.$Jump.href("/cart");
    },
    // 获取购物车列表
    getCarList() {
      // 避免首页&改密码页面未登录弹登录框
      if (!this.userInfo?.buyerUserId) {
        return;
      }
      this.$Api.shop
        .getCarList({ type: 1 })
        .then((res) => {
          this.$store.commit("user/setMyCarList", res.data.data);
        })
        .catch(() => { });
    },
    // 个人设置
    goSetting() {
      this.$Jump.href("/setting");
    },
    // 个人中心
    goPersonalCenter() {
      this.href("/personalCenter");
    },
    // 订单列表
    goOrderList() {
      this.$Jump.href("/orderList");
    },
    // 优惠券
    goCoupon() {
      this.$Jump.href("/coupon");
    },
    // 返回主页
    goHome() {
      this.$Jump.href("/");
    },
    // 获取热门城市
    getHotCityList() {
      this.hotCityList = [];
      for (let key in area.hot_city_list) {
        this.hotCityList.push({ cityId: key, cityName: area.hot_city_list[key] });
      }
    },
    changeTopMenu(value) {
      this.topSelectedMenu = value;
      if (this.topSelectedMenu == 1) {
        this.$Jump.href("/teacher", { topSelectedMenu: this.topSelectedMenu });
      } else if (this.topSelectedMenu == 2) {
        this.$Jump.href("/learningCenter", { topSelectedMenu: this.topSelectedMenu });
      } else if (this.topSelectedMenu == 3) {
        this.$Dialog.toast("功能开发中", { type: "error" });
        // this.$Jump.href("/memberArea", { topSelectedMenu: this.topSelectedMenu });
      } else if (this.topSelectedMenu == 4) {
        this.$Dialog.toast("功能开发中", { type: "error" });
      } else if (this.topSelectedMenu == 0) {
        this.$Jump.href("/");
      } else if (this.topSelectedMenu == 6) {
        this.$Jump.href("/examinationCenter", { topSelectedMenu: this.topSelectedMenu });
      }
    },
    // 消息中心
    goMessage() {
      // this.$Jump.href("/message");
      this.$Jump.href("/goEasy/pages/conversations");
    },
    // 获取热门搜索关键词
    getHotSearch() {
      this.$Api.common
        .getHotSearch({ topN: 10 })
        .then((res) => {
          this.hotSearchList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 搜索
    searchCourse(value) {
      if (!value) {
        this.$Dialog.toast("请输入搜索内容", { type: "error" });
        return;
      }
      // 判断当前页是不是搜索页面
      if (this.$route.path == "/searchList") {
        this.courseName = value;
        this.$emit("changeCourseCommonSearch");
      } else {
        this.courseName = "";
        this.href("/searchList", { searchValue: value });
      }
      this.$store.commit("user/setHistorySearchList", value);
    },
    // 删除历史记录
    deleteHistorySearch() {
      this.$Dialog.confirm({
        message: "是否清空历史记录",
        title: "提示", // 可选，不传则使用默认值'确认'
        onConfirm: () => {
          this.$store.commit("user/setEmptyHistorySearchList", []);
        }, // 确认后的操作，如调用删除API等
        onCancel: () => { }, // 取消后的操作，可选不传则无动作。也可以在这里添加其他逻辑。
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.common_top_box_space {
  width: 100%;
  height: $pageTopHeight;
  background-color: #fff;
  position: fixed;
  top: 0;
  z-index: 99;
  box-shadow: rgba(146, 157, 154, 0.3) 0px 4px 10px 0px;
}

.common_top_box {
  z-index: $zIndexTop;
  display: flex;
  width: 100%;
  height: $pageTopHeight;
  padding: 0 20px;
  box-sizing: border-box;

  .gjkc_index_logo {
    width: 50px;
    height: 50px;
  }

  .menu_list {
    max-width: 700px;
    overflow-x: auto;
    // border-bottom: 1px solid rgba(20, 20, 20, 0.1);

    .menu_one {
      line-height: 50px;
      margin: 0 10px;
      position: relative;
      font-size: 14px;
      font-weight: normal;
      color: #1D2129;
    }

    .line_active {
      position: absolute;
      bottom: 0;
      width: 50px;
      height: 2px;
      background: #13d6aa;
    }

    .active_text {
      color: #13d6aa;
      font-weight: 600;
    }
  }

  :deep(.el-select__wrapper) {
    box-shadow: none;
  }

  :deep(.el-select__wrapper.is-focused) {
    box-shadow: none;
  }

  :deep(.el-select__selected-item) {
    font-family: monospace;
    font-weight: bold;
    font-size: 19px;
    color: #111111;
  }

  :deep(.el-select__icon) {
    color: #333333;
    width: 16px !important;
    height: 16px !important;
  }

  :deep(.el-select__icon svg) {
    width: 16px !important;
    height: 16px !important;
  }

  .logo_img {
    width: 230px;
    height: 50px;
  }

  .common_top_box_right {
    width: 50%;
  }

  .area_box {
    width: 128px;
    height: 40px;
    border-radius: 11px;
    border: 1px solid #efefef;
    color: #1D2129;
    position: relative;
    font-size: 14px;

    .position_icon {
      width: 22px;
      height: 22px;
    }

    .dropdown-menu {
      position: absolute;
      top: 40px;
      background-color: #fff;
      border: 1px solid #ccc;
      width: 100%;
      z-index: 1;
      width: 201px;
      // height: 140px;
      padding: 11px;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);
      border-radius: 10px;
    }

    .hotCity {
      font-weight: bold;
      font-size: 16px;
      color: #1D2129;
    }

    .dropdown-item {
      padding: 5px 10px;
      cursor: pointer;
      font-size: 14px;
      color: #1D2129;
    }

    .active_city {
      color: #13d6aa;
    }

    .dropdown-item:hover {
      background-color: #f0f0f0;
    }

    .more-cities {
      margin-right: 10px;
      color: #1D2129;
      margin-top: 10px;
    }
  }

  .top_input_box {

    :deep(.el-input-group__append),
    .el-input-group__prepend {
      padding: 0;
      border-radius: 0px 10px 10px 0px;
    }

    :deep(.el-input__wrapper) {
      border-radius: 10px 0px 0px 10px;
    }

    :deep(.el-input__inner) {
      color: #666666;
    }

    .btn_search {
      text-align: center;
      line-height: 40px;
      width: 67px;
      height: 40px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 0px 10px 10px 0px;
      color: #ffffff;
    }
  }

  .top_search_box {
    position: relative;

    .search_tooltip_box {
      position: absolute;
      top: 40px;
      left: 0;
      width: 325px;
      padding: 20px;
      box-sizing: border-box;
      // max-height: 232px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.05);
      border-radius: 10px;

      .hot_title {
        font-weight: 600;
      }

      .top_search_delete_icon {
        width: 24px;
        height: 24px;
      }

      .hot_search_list {
        width: 100%;
        font-size: 14px;
        color: #333333;

        .hot_search_list_one {
          width: 50%;
        }
      }

      .history_list {
        width: 90%;
        font-size: 14px;
        color: #333333;

        .history_list_one {
          margin-left: 15px;
        }
      }
    }
  }

  .top_icon_box {
    .car_icon {
      width: 30px;
      height: 30px;
    }
  }

  .top_btn_box {
    .btn_outline {
      // margin-left: 18px;
      font-size: 14px;
      color: #1D2129;
      position: relative;
      width: 82px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      box-sizing: border-box;

      .member_benefits {
        position: absolute;
        top: 50px;
        left: -160px;
        background-color: #fff;
        border: 1px solid #ccc;
        width: 100%;
        z-index: 1;
        width: 400px;
        // height: 220px;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);
        border-radius: 10px;

        .member_benefits_top {
          margin-top: 15px;

          .line_y_left {
            width: 47px;
            height: 6px;
          }

          .title_text {
            color: #977140;
            font-weight: 600;
            margin: 0 10px;
            font-size: 18px;
          }
        }

        .member_benefits_content {
          .content_one {
            width: 50%;
            margin-top: 20px;
            padding: 0 15px;
            box-sizing: border-box;
            font-size: 14px;
            color: #b89e7d;

            .video_y_icon {
              width: 28px;
              height: 28px;
            }

            .video_text {
              margin-left: 8px;
            }
          }
        }

        .btn_open_member {
          width: 272px;
          height: 40px;
          background: linear-gradient(-35deg, #edc58e 0%, #fae0bb 99%);
          border-radius: 20px;
          color: #875427;
          line-height: 40px;
          text-align: center;
          margin-top: 20px;
          margin-bottom: 20px;
        }

        .member_bg {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 282px;
          height: 182px;
        }
      }
    }

    .active_top_menu {
      background: linear-gradient(90deg, #00d5c2, #00d498);
      color: #fff;
      font-weight: 600;
    }
  }

  .login_box {
    font-size: 14px;
    color: #13d6aa;

    .user_avatar_box {
      position: relative;

      .user_info_box {
        left: -30px;
        position: absolute;
        width: 91px;
        // height: 132px;
        background: #ffffff;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        padding-top: 10px;
        padding-bottom: 10px;
      }
    }

    .user_avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }
  }
}

.moe_top {
  width: 100%;
  height: $pageTopHeight;
}
</style>
